import { ICellRendererParams } from '@ag-grid-community/core'
import { generateMdiIcon } from '@helios/ag-grid-config'
import { IconClasses } from './account-list-grid-helpers'

/**
 * Renders compliance violation as a string of html code.
 * The display logic depends on hasComplianceTimestamp and follows these rules:
 * +----------------------------------+---------------------------------+----------------------------------------------+
 * |                                  | hasComplianceTimestamp is true  | hasComplianceTimestamp is false or undefined |
 * +----------------------------------+---------------------------------+----------------------------------------------+
 * | complianceViolation is undefined | Green Completed Icon, no number | No icon, no number                           |
 * | complianceViolation is defined   | Green Completed Icon, number    | Red Danger Icon, number                      |
 * +----------------------------------+---------------------------------+----------------------------------------------+
 *
 * @param params AG Grid cell renderer params
 * @returns HTML formatted string representation of the compliance violation count
 */
export const complianceViolationCellRenderer = (
  params: ICellRendererParams,
): string => {
  const complianceViolations: number | undefined = params.value
  const hasComplianceTimestamp: boolean | undefined =
    params.data?.hasComplianceTimestamp

  const complianceTimestampDisplay = hasComplianceTimestamp
    ? generateMdiIcon(IconClasses.completed, ['text-success'])
    : complianceViolations === undefined
    ? ''
    : generateMdiIcon(IconClasses.high, ['text-danger'])
  const complianceViolationsDisplay =
    complianceViolations === undefined ? '' : ` ${complianceViolations}`
  return `${complianceTimestampDisplay}${complianceViolationsDisplay}`
}
